export default {
    FAKTURA_title: 'Faktura',
    FAKTURA_emptyList: 'Fant ingen fakturaer',
    FAKTURA_emptyListTitle: 'Du har ingen fakturaer ennå',
    FAKTURA_emptyListDescription: 'Vi sender fakturaer en gang i måneden.',
    FAKTURA_error:
        'Vi beklager, vi det har skjedd en teknisk feil så du kan ikke sjekke faktura dine akkurat nå. Prøv igjen litt senere.',
    FAKTURA_select: 'Se faktura',
    FAKTURA_listFetchError: 'Vi beklager, fakturaer kan ikke hentes. Prøv igjen litt senere.',
    FAKTURA_itemFetchError: 'Vi beklager, fakturaen kan ikke hentes. Prøv igjen litt senere.',

    AARSOPPGAVE_title: 'Årsoppgave',
    AARSOPPGAVE_emptyList: 'Fant ingen årsoppgaver',
    AARSOPPGAVE_emptyListTitle: 'Du har ingen årsoppgaver ennå',
    AARSOPPGAVE_emptyListDescription: 'Vi sender årsoppgave en gang hvert år.',
    AARSOPPGAVE_error:
        'Vi beklager, vi det har skjedd en teknisk feil så du kan ikke sjekke årsoppgavene dine akkurat nå. Prøv igjen litt senere.',
    AARSOPPGAVE_select: 'Se årsoppgave',
    AARSOPPGAVE_listFetchError: 'Vi beklager, årsoppgaver kan ikke hentes. Prøv igjen litt senere.',
    AARSOPPGAVE_itemFetchError: 'Vi beklager, årsoppgaven kan ikke hentes. Prøv igjen litt senere.',

    DOKUMENT_title: 'Dokumenter',
    DOKUMENT_emptyList: 'Fant ingen dokumenter',
    DOKUMENT_emptyListTitle: 'Du har ingen dokumenter',
    DOKUMENT_emptyListDescription: '',
    DOKUMENT_error:
        'Vi beklager, vi det har skjedd en teknisk feil så du kan ikke sjekke dokumentene dine akkurat nå. Prøv igjen litt senere.',
    DOKUMENT_select: 'Se dokument',
    DOKUMENT_listFetchError: 'Vi beklager, dokumenter kan ikke hentes. Prøv igjen litt senere.',
    DOKUMENT_itemFetchError: 'Vi beklager, dokumentet kan ikke hentes. Prøv igjen litt senere.',

    invoiceLabel_INVOICE: 'Faktura',
    invoiceLabel_YEARLY_STATEMENT: 'Årsoppgave',
    invoiceLabel_OVERDUE_NOTICE: 'Purring',
    invoiceLabel_CHANGE_NOTICE: 'Endring av avtalevilkår',
    invoiceLabel_PRICE_CHANGE_NOTICE: 'Varsel om prisendring',
    invoiceLabel_CREDIT_CARD_INFO: 'Informasjon om ditt kredittkort',
    invoiceLabel_RATE_CHANGE: 'Renteendring',
    invoiceLabel_MERGER: 'Varselbrev Sammenslåing',
    invoiceLabel_UNKNOWN: 'Dokument',

    documentSeeYearlyStatements: 'Se årsoppgave',
    documentSeeInvoice: 'Se faktura',
    documentsTitle: 'Faktura og dokumenter',
    documentsIngress: 'Her kan du se og laste ned fakturaer og dokumenter for kredittkortene dine.',
    documentFetchError: 'Noe gikk galt under henting av dokumenter. Vennligst prøv igjen senere.',
    documentPDFFetchError: 'Noe gikk galt under henting av PDF. Vennligst prøv igjen senere.',
    documentClose: 'Lukk',
    documentZoomIn: 'Zoom inn',
    documentZoomOut: 'Zoom ut',
    documentDownload: 'Last ned',
    documentNextPage: 'Neste side',
    documentPrevPage: 'Forrige side',
    documentPage: 'Side',
    documentInvoiceYearStatementTitle: 'Se fakturaer og dokumenter for kredittkortet ditt',
    documentInvoiceEmptyListTitle: 'Du har ingen faktura enda',
    documentInvoiceEmptyListText: 'Vi sender faktura en gang i måneden.',
    documentYearStatementEmptyListTitle: 'Du har ingen årsoppgaver enda',
    documentYearStatementEmptyListText: 'Vi sender årsoppgave en gang hvert år.',
    documentLoadingErrorTitle: 'Oj sann!',
};
